export default __webpack_public_path__ + "static/media/rio_cover.4fac90a0.jpg";